let endPoint = '';
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') endPoint = 'http://localhost:3336';
else endPoint = 'https://apiintegra.manserv.com.br:3000';

export const serverEndPoint = endPoint;
